import { Loading } from '@appkit4/react-components';
import './sectionLoader.scss';

const SectionLoader = () => {
    return (
        <div className="section-loader-container">
            <Loading
                loadingType="linear"
                indeterminate={true}
                compact={false}
                className="section-loader"
            />
        </div>
    );
};

export default SectionLoader;